<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import IntuneWipe from './wipe_alerts'

export default {
  page: {
    title: 'Intune Wipe Alerts',
    meta: [{ name: 'description', content: appConfig.description }]
  },
	components: { Layout, PageHeader, IntuneWipe },
  data () {
    return {
      title: 'Intune Wipe Alerts',
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Intune Wipe Alerts',
          active: true
        }
      ]
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required }
    }
  },
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<IntuneWipe :url="'/intune/wipe_alerts/list?'" />
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
